import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { ProviderServiceOptionSummaryModel } from "../providerServiceOptionSummary.model";
import { Injectable } from '@angular/core';
import {PermissionsConverter} from "../../../../../../common/converter/permissions.converter";

@Injectable({
    providedIn: 'root'
})
export class ProviderServiceOptionSummaryConverter extends HttpModelConverter<ProviderServiceOptionSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): ProviderServiceOptionSummaryModel {
        return new ProviderServiceOptionSummaryModel();
    }

    protected enrichObject(result: ProviderServiceOptionSummaryModel, src: ProviderServiceOptionSummaryModel): void {
        result.permissions = this.permissionConverter.convert(src.permissions);
    }
}

